var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { inject, observer } from 'mobx-react';

import { Editor } from '../Editor';

export var CheckboxCellEditor = function CheckboxCellEditor(_ref) {
  var cell = _ref.cell,
      update = _ref.update;
  return React.createElement(
    Editor,
    { contentEditable: true, suppressContentEditableWarning: true,
      onFocus: function onFocus(e) {
        window.getSelection().selectAllChildren(e.target);
      },
      onBlur: function onBlur(e) {
        var _extends2;

        var field = cell.column.id;
        var value = e.target.textContent;
        update(_extends({}, cell.original, (_extends2 = {}, _extends2[field] = value, _extends2)));
      }
    },
    cell.value
  );
};

export var CheckboxFieldEditor = inject('store')(observer(function (_ref2) {
  var store = _ref2.store,
      field = _ref2.field;
  return React.createElement('input', { type: 'checkbox', checked: store.selected[field],
    onChange: function onChange(e) {
      var value = e.target.checked;
      store.updateField(field, value);
    }
  });
}));